import cn from 'classnames';

import { useTemplate } from 'src/hooks/useTemplate';

import { LinkData } from 'src/types/components';

import Link from '../Link';
import StartIndex from '../StartIndex';
import StopIndex from '../StopIndex';
import Text from '../Text';

import styles from './Breadcrumbs.module.scss';

export type BreadcrumbsProps = {
  breadcrumbs?: Array<LinkData>;
  className?: string;
};

const Breadcrumbs = (props: BreadcrumbsProps): JSX.Element => {
  const { breadcrumbs, className } = props;
  if (!breadcrumbs || breadcrumbs.length <= 1) {
    return <></>;
  }

  const { isNewsInsight, isEvent } = useTemplate();

  return (
    <>
      <StopIndex />
      <nav aria-label="Breadcrumb" className={styles.main}>
        <ul className={cn(styles.breadcrumbs, className)}>
          {breadcrumbs.map((breadcrumb, index) => {
            const isLast = index === breadcrumbs.length - 1;
            return (
              <li key={`breadcrumb-${index}`} className={cn(styles.breadcrumb)}>
                {!isLast ? (
                  <Link href={breadcrumb.href} className={cn(styles.link, 'body-eyebrow')}>
                    {breadcrumb.label}
                  </Link>
                ) : (
                  <Text
                    className={cn(styles.label, 'body-sm', {
                      [styles['truncate']]: isNewsInsight || isEvent,
                    })}
                    aria-current="page"
                    field={breadcrumb.label}
                  />
                )}
              </li>
            );
          })}
        </ul>
      </nav>
      <StartIndex />
    </>
  );
};

export default Breadcrumbs;
